import {
  CarouselElementContainer,
  CarouselContainer,
  FlexContainer,
  MobileCarouselElementContainer,
  CTAContainer,
} from './OffersCardsSkeletonLoader.styles';

interface OffersCardsSkeletonLoaderProps {
  isMobileViewPort: boolean;
}

export const OffersCardsSkeletonLoader: React.FC<OffersCardsSkeletonLoaderProps> = ({ isMobileViewPort }) => {
  const totalCards = 4;
  const enableCardElementsLoader = true;

  const renderCards = () => {
    return Array.from({ length: totalCards }, (_, index) => (
      <div key={index} className="standard-container">
        <div
          className={`skeleton-loader skeleton-loader-composite ${isMobileViewPort ? 'square' : 'wide'} ${
            enableCardElementsLoader && 'skeleton-details'
          }`}
        >
          {enableCardElementsLoader && (
            <div className="skeleton-card-content">
              <div className="skeleton-loader card-eyebrow"></div>
              <div className="skeleton-loader card-text"></div>
            </div>
          )}
        </div>
      </div>
    ));
  };

  return isMobileViewPort ? (
    <CarouselContainer data-testid="carousel-container-skeleton-loader">
      <FlexContainer>
        <div className="skeleton-loader carousel-heading"></div>
        <div className="skeleton-loader carousel-subheading"></div>
      </FlexContainer>

      <MobileCarouselElementContainer>{renderCards()}</MobileCarouselElementContainer>

      <CTAContainer>
        <div className="skeleton-loader offercard-carousel-cta"></div>
      </CTAContainer>
    </CarouselContainer>
  ) : (
    <CarouselContainer data-testid="carousel-container-skeleton-loader">
      <FlexContainer>
        <div className="skeleton-loader carousel-heading"></div>
        <div className="skeleton-loader carousel-subheading"></div>
      </FlexContainer>

      <CarouselElementContainer>{renderCards()}</CarouselElementContainer>

      <CTAContainer>
        <div className="skeleton-loader offercard-carousel-cta"></div>
      </CTAContainer>
    </CarouselContainer>
  );
};
